export const LOCALES = {
  ENGLISH: "en-US",
  GERMAN: "de-DE",
  DANISH: "da-DK",
};
